

































































































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import ExamListCategory from '../atoms_molecules/ExamListCategory.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import Exam from '../../models/exam'
import { examState } from '../../stores/exam'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import Category from '../../models/category'
import { userState } from '../../stores/user'
import { format } from 'date-fns'
import { checkMobile } from '../../utils/utils'

@Component({
  components: {
    ExamListCategory
  }
})
export default class ExamList extends Vue {
  isMobile: boolean = false
  mobile = checkMobile()
  drawerRight = !this.mobile
  LETTER_FORMAT = LETTER_FORMAT
  isLoadingSearch: boolean = false
  items: string[] = []
  model: string = ""
  search: string = ""

  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'テスト一覧',
      disabled: false,
      exact: true,
      to: '/classroom/exam-list'
    }
  ]

  get exams() {
    return examState.listExam.list
  }

  get user() {
    return userState.user
  }

  get categories() {
    return examState.listExam.categories
  }

  get isLoading() {
    return examState.listExam.isLoading
  }

  get pagination() {
    return examState.listExam.pagination
  }

  get currentExams(): Exam[] {
    const listId = this.$route.query['list_id']
    if (!listId) {
      return this.exams
    }

    const category = this.findCategoryById(Number(listId))
    return category ? category.getExams(this.exams) : []
  }

  async getSearchValue() {
    if (this.search) {
      this.search = ''
      await examState.searchExam(this.search)
    }
  }
  get examsInfo(): {
    id: number
    name: string
    image: string
    price: number
    difficultRate: number
    passRate: number
    averageRate: number
    usersCount: number
    hasTested: boolean
    description: string
    to: string
  }[] {
    return this.exams.map((exam) => {
      const base = {
        id: exam.id,
        name: exam.name,
        image: exam.image && exam.image.url ? exam.image.url : exam.examImageUrl,
        price: exam.price,
        difficultRate: exam.difficultRate,
        passRate: exam.passRate,
        averageRate: exam.averageRate,
        usersCount: exam.usersCount
      }

      const testInfo = {
        hasTested: false,
        description: '',
        to: `/classroom/exam-list/${exam.id}`
      }

      if (exam.userExams.length > 0) {
        testInfo.hasTested = true
        const userExam = exam.userExams[0]

        if (userExam.finishedAt) {
          testInfo.description = `${this.dateFormat(userExam.createdAt)}に実行済み`
          testInfo.to = `/classroom/my-exams/${exam.id}/result`
        } else {
          testInfo.description = `${this.dateFormat(userExam.createdAt)}に受け済み`
          testInfo.to = `/classroom/my-exams/${exam.id}`
        }
      }
      return {
        ...base,
        ...testInfo
      }
    })
  }

  get title(): string {
    const listId = this.$route.query['list_id']
    if (!listId) {
      return 'すべてのテスト'
    }
    const category = this.findCategoryById(Number(listId))
    return category ? `${category.name}のテスト` : ''
  }

  async created() {
    await examState.getCategories()
    headerState.setTitle('テスト一覧')
    footerState.setFooterDefault()
  }

  @Watch('$route', { immediate: true })
  async onChangeQueryRoute() {
    const listId = this.$route.query['list_id'] as string
    await examState.getList(1, listId)
  }

  clickCategory(category: Category) {
    this.$router.push({ query: { list_id: category.id.toString() } })
  }

  @Watch('search')
  async getExamFromSearch() {
    if (this.search) {
      await examState.searchExam(this.search)
    }
  }

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  }

  selectPage(page) {
    examState.getList(page)
  }

  onResize() {
    this.isMobile = window.innerWidth < 600
  }

  findCategoryById(id: number) {
    for (let index = 0; index < this.categories.length; index++) {
      const category = this.categories[index].find(id)
      if (category) {
        return category
      }
    }
    return null
  }

  resetCategory() {
    this.$router.push({ query: {} })
  }

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }
  }

  dateFormat(date: Date) {
    return format(date, 'YYYY/MM/DD HH:mm')
  }
}
